/**
 * Badge de statut pour les tickets
 */

import { useTranslation } from 'react-i18next';
import type { TicketStatus } from '../types/tickets.types';

interface TicketStatusBadgeProps {
  status: TicketStatus;
  size?: 'sm' | 'md';
}

const statusStyles: Record<TicketStatus, string> = {
  OPEN: 'bg-blue-50 text-blue-700 border-blue-200',
  IN_PROGRESS: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  WAITING_USER: 'bg-orange-50 text-orange-700 border-orange-200',
  WAITING_INTERNAL: 'bg-purple-50 text-purple-700 border-purple-200',
  RESOLVED: 'bg-teal-50 text-teal-700 border-teal-200',
  CLOSED: 'bg-gray-50 text-gray-600 border-gray-200',
};

const statusI18nKeys: Record<TicketStatus, string> = {
  OPEN: 'support.status.OPEN',
  IN_PROGRESS: 'support.status.IN_PROGRESS',
  WAITING_USER: 'support.status.WAITING_USER',
  WAITING_INTERNAL: 'support.status.WAITING_INTERNAL',
  RESOLVED: 'support.status.RESOLVED',
  CLOSED: 'support.status.CLOSED',
};

export function TicketStatusBadge({ status, size = 'md' }: TicketStatusBadgeProps) {
  const { t } = useTranslation();
  const className = statusStyles[status] || statusStyles.OPEN;
  const labelKey = statusI18nKeys[status] || statusI18nKeys.OPEN;

  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border backdrop-blur-sm
                  transition-all duration-200 hover:shadow-sm ${className} ${sizeClasses}`}
    >
      {t(labelKey)}
    </span>
  );
}
